import { /* Avatar, */ AvatarSize } from "../Avatar";
import { ColorKeys } from "@/theme/colors";
import "./AuthorBlock.scss";
import { Row } from "@/components";
import { HeadingLevel } from "@/types/headings";

type CardAuthorProps = {
  titleTag?: HeadingLevel;
  authorName: string;
  avatar?: {
    initials: string;
    bg?: ColorKeys;
    textColor?: ColorKeys;
  };
  avatarSize?: AvatarSize;
  publishedLabel?: string;
  publishedDate?: string;
  readingTimeLabel?: string;
  readingTimeValue?: number;
  readingMinuteLabel?: string;
};

export const AuthorBlock = ({
  /*titleTag: TitleTag = "h1",
   authorName,
  avatar,
  avatarSize = "3", */
  publishedLabel = "Pubblicato il",
  publishedDate = "-",
  readingTimeLabel = "Tempo di lettura",
  readingTimeValue = 0,
  readingMinuteLabel = "minuti",
}: CardAuthorProps) => {
  return (
    <article className="bg-white br-x4 ui-card-author">
      <Row as={"header"} gap={"x16"} className="align-items-center">
        {/* avatar && (
          <Avatar
            textColor={avatar?.textColor ?? "slate-20"}
            bg={avatar?.bg ?? "lightblue-a01"}
            initials={avatar?.initials ?? ""}
            className="ui-card-author-avatar"
            size={avatarSize}
          />
        ) */}

        <div className={"text-slate-28"}>
          {/* <TitleTag className="fs-5 md-fs-custom fw-semibold ">
            {authorName}
          </TitleTag> */}
          <div className={"base-row gap-x8 fs-6 text-slate-28"}>
            <div className={"item-block"}>
              <p className="fw-regular">{publishedLabel}</p>
              <p className={"fw-bold"}>{publishedDate}</p>
            </div>

            <div className={"item-block ui-author-divider"}>
              <p className="fw-regular ">{readingTimeLabel}</p>
              <p className={"fw-bold"}>
                {readingTimeValue} {readingMinuteLabel}
              </p>
            </div>
          </div>
        </div>
      </Row>
    </article>
  );
};
